import { Navigate } from 'react-router-dom';
import { useAuthConnect } from '../hooks/useAuth';
import AepsTransaction from './bankingServices/AEPS(AEPS)/Aeps1/Aeps1';
import AadhaarPay from './bankingServices/AEPS(AEPS)/AadhaarPay';

const AuthCheckAeps = () => {
    useAuthConnect();
    const authToken = localStorage.getItem('AuthToken');

    if (authToken) {
        // Check path to decide which page to render
        if (location.pathname.includes('/aeps1/aadhaarpay')) {
            return <AadhaarPay />;
        } else if (location.pathname.includes('/aeps1/aeps')) {
            return <AepsTransaction />;
        }
    } else {
        // fallback if no match
        <Navigate to="/unauthorized-section" replace />;
    }
};

export default AuthCheckAeps;
